import { motion } from "framer-motion";
import { HERO, INSTITUTION, STATS } from "../data/content";

export const Hero = () => {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-xs uppercase tracking-overline text-[#5B3E96] font-semibold mb-6"
            >
              {HERO.overline}
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#2D1B4E] tracking-tight leading-[1.05]"
            >
              {HERO.title}
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.25 }}
              className="mt-7 text-base md:text-lg text-[#5F5670] max-w-xl leading-relaxed"
            >
              {HERO.subtitle}
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.4 }}
              className="mt-9 flex flex-wrap gap-4"
            >
              <a
                href="#nosotros"
                data-testid="hero-primary-cta"
                className="bg-[#2D1B4E] text-white text-sm font-medium px-7 py-3.5 rounded-sm hover:bg-[#1A1523] transition-colors"
              >
                ¿Qué podrás encontrar aquí?
              </a>
              <a
                href="#contacto"
                data-testid="hero-secondary-cta"
                className="border border-[#2D1B4E]/30 text-[#2D1B4E] text-sm font-medium px-7 py-3.5 rounded-sm hover:bg-[#F4F2F7] transition-colors"
              >
                Contáctanos
              </a>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-6 relative"
          >
            <div className="absolute -top-6 -left-6 w-28 h-28 border-t-2 border-l-2 border-[#5B3E96]/40 hidden md:block" />
            <img
              src={HERO.image}
              alt="Escudo Universidad Politécnica de Pachuca"
              data-testid="hero-image"
              className="w-full h-[380px] md:h-[520px] object-contain bg-[#2D1B4E] rounded-sm shadow-xl"
            />
          </motion.div>
        </div>

        <div
          data-testid="stats-row"
          className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20 pt-12 border-t border-[#E8E4EE]"
        >
          {STATS.map((s) => (
            <div key={s.label}>
              <p className="font-serif-display text-4xl md:text-5xl font-semibold text-[#2D1B4E]">
                {s.value}
              </p>
              <p className="text-sm text-[#5F5670] mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
